import { Dom } from '@brandocms/jupiter'
import gsap from 'gsap'

export default _app => ({
  logoColor: '#000',
  logoPathSelector: 'svg path',
  contentSelector: 'section.main',
  hamburgerColor: '#000',

  onResize: m => {
    if (document.body.classList.contains('open-menu')) {
      gsap.set(m.bg, { height: window.innerHeight })
    }
  },

  openTween: m => {
    const timeline = gsap.timeline()
    const menuButton = Dom.find('.menu-button')
    menuButton.classList.toggle('is-active')
    m.hamburger.classList.toggle('is-active')
    document.body.classList.toggle('open-menu')
    // set hamburger text
    const hamburgerTextEl = Dom.find(m.hamburger, 'span')
    const newText = m.hamburger.dataset.closeText
    hamburgerTextEl.innerHTML = newText

    // Dispatch event for NavTeleport module BEFORE animation starts
    // so the triangle nav is already in place when menu slides in
    window.dispatchEvent(new CustomEvent('mobilemenu:open'))

    timeline
      .set(m.bg, { display: 'block' })
      .to(m.bg, { x: 0, xPercent: 0, ease: 'power2.inOut' })
      .call(() => {
        m._emitMobileMenuOpenEvent()
        // lock scroll
        // app.scrollLock()
      })
  },

  closeTween: m => {
    const timeline = gsap.timeline()
    const menuButton = Dom.find('.menu-button')
    // set hamburger text
    const hamburgerTextEl = Dom.find(m.hamburger, 'span')
    const newText = m.hamburger.dataset.openText
    hamburgerTextEl.innerHTML = newText
    timeline
      .call(() => {
        m._emitMobileMenuClosedEvent()
        document.body.classList.toggle('open-menu')
        m.hamburger.classList.toggle('is-active')
        menuButton.classList.toggle('is-active')
        // app.scrollRelease()
      })
      .to(m.bg, { xPercent: 100, ease: 'power2.inOut' })
      .set(m.bg, { display: 'none' })
      .call(() => {
        // Dispatch event for NavTeleport module AFTER animation completes
        // so the triangle nav doesn't disappear while menu is still visible
        window.dispatchEvent(new CustomEvent('mobilemenu:closed'))
      })
  },
})
